import { ConfigurationType } from "_interfaces";
import { API_ENDPOINT } from "_lib/utils";
import axios from "axios";
import { atom, selector } from "recoil";

const ConfigurationSelector = selector<ConfigurationType>({
  key: "ConfigurationSelector",
  get: async ({ get }) => {
    try {
      const res = await axios.get(
        `${API_ENDPOINT}/items/configurations?fields[]=*,featured_destinations.destinations_id.name,featured_destinations.destinations_id.slug,featured_destinations.destinations_id.image,featured_destinations.destinations_id.starting_price,featured_tours.tours_id.id,featured_tours.tours_id.name,featured_tours.tours_id.image,featured_tours.tours_id.nights,featured_tours.tours_id.starting_price`
      );
      const data: ConfigurationType = {
        site_name: res.data.data.site_name,
        short_description: res.data.data.short_description,
        contact_number: res.data.data.contact_number,
        contact_email: res.data.data.contact_email,
        facebook_url: res.data.data.facebook_url,
        twitter_url: res.data.data.twitter_url,
        instagram_url: res.data.data.instagram_url,
        linkedin_url: res.data.data.linkedin_url,
        youtube_url: res.data.data.youtube_url,
        featured_destinations: res.data.data.featured_destinations.map(
          (d: any) => {
            return {
              name: d.destinations_id.name,
              slug: d.destinations_id.slug,
              image: `${API_ENDPOINT}/assets/${d.destinations_id.image}/${d.destinations_id.name}.jpg`,
            };
          }
        ),
        featured_tours: res.data.data.featured_tours.map((t: any) => {
          return {
            id: t.tours_id.id,
            name: t.tours_id.name,
            nights: t.tours_id.nights,
            starting_price: t.tours_id.starting_price,
            image: t.tours_id.image
              ? `${API_ENDPOINT}/assets/${t.tours_id.image}/${t.tours_id.id}.jpg`
              : null,
          };
        }),
      };
      return data;
    } catch (error) {
      console.error(error);
      return {} as ConfigurationType;
    }
  },
});

const ConfigurationAtom = atom<ConfigurationType>({
  key: "ConfigurationAtom",
  default: ConfigurationSelector,
});

export { ConfigurationAtom };
